import api from "../../../api/api";

export const extractFile = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post("/ai-assistant/extract-file", formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
};

export const classifyData = (data, options) =>
  api.post("/ai-assistant/classify-data", { data, options });
